import { render, staticRenderFns } from "./ExternalLinkImportNotification.vue?vue&type=template&id=101e1b18"
import script from "./ExternalLinkImportNotification.vue?vue&type=script&lang=js"
export * from "./ExternalLinkImportNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports